import ActionTypes from "../../../constants/ActionTypes";
import {
  ICloseMapActions,
  IGetAllStoresActions,
  ISetStoresActions,
  ISetStoresMapVisibilityActions,
  IStore,
  IMapCenter,
  ISetMapCenterActions,
  IGetUserGeoLocationActions,
  ISetUserGeolocationActions
} from "./types";

export function getAllStoresMapAction(productId: string | number, colorId: string | number, lang: string): IGetAllStoresActions {
  return {
    type: ActionTypes.STORES_MAP.GET_ALL_STORES,
    payload: {
      params: {
        productId: productId,
        colorId: colorId,
        lang: lang
      }
    }
  };
}

export function setStoresMapVisibilityAction(visibility: boolean): ISetStoresMapVisibilityActions {
  return {
    type: ActionTypes.STORES_MAP.SET_VISIBILITY,
    payload: visibility,
  };
}

export function setStoresMapAction(stores: IStore[]): ISetStoresActions {
  return {
    type: ActionTypes.STORES_MAP.SET_STORES,
    payload: stores
  };
}

export function closeMapAction(): ICloseMapActions {
  return {
    type: ActionTypes.STORES_MAP.CLOSE,
  };
}

export function getUserGeoLocationAction(): IGetUserGeoLocationActions {
  return {
    type: ActionTypes.STORES_MAP.GET_USER_GEO_LOCATION
  };
}

export function setMapCenterAndZoomAction(center:IMapCenter, zoom: number): ISetMapCenterActions {
  return {
    type: ActionTypes.STORES_MAP.SET_MAP_CENTER,
    payload: {
      center: center,
      zoom: zoom,
    }
  };
}

export function setUserGeolocationAction(lat: number, lon: number): ISetUserGeolocationActions {
  return {
    type: ActionTypes.STORES_MAP.SET_USER_GEO_LOCATION,
    payload: { lat, lon }
  };
}

export function setActiveStoreId(id: string | number) {
  return {
    type: ActionTypes.STORES_MAP.SET_ACTIVE_STORE_ID,
    payload: id,
  };
}

export function setStoreFilterAction(filter: any[]) {
  return {
    type: ActionTypes.STORES_MAP.SET_STORE_FILTER,
    payload: filter,
  };
}

export function setFiveClosestStatusAction() {
  return {
    type: ActionTypes.STORES_MAP.SET_FIVE_CLOSEST_STATUS
  };
}

export function setFiveClosestAction(status: boolean) {
  return {
    type: ActionTypes.STORES_MAP.SET_CLOSEST_STORES_STATUS,
    payload: status,
  };
}

export function getClosestStoresAction() {
  return {
    type: ActionTypes.STORES_MAP.GET_CLOSEST_STORES
  };
}

export function getCitiesAction(stores: any[]) {
  return {
    type: ActionTypes.STORES_MAP.GET_CITIES,
    payload: stores,
  };
}

export function setCitiesAction(cities: string[]) {
  return {
    type: ActionTypes.STORES_MAP.SET_CITIES,
    payload: cities,
  };
}

export function getOnlyStoresAction(lang: string) {
  return {
    type: ActionTypes.STORES_MAP.GET_ONLY_STORES,
    payload: {
      params: {
        lang
      }
    }
  };
}

export function getMultipleProductStoreAvailabilityAction(lang: string, items?: any[]) {
  return {
    type: ActionTypes.STORES_MAP.GET_MULTIPLE_PRODUCT_STORE_AVAILABILITY,
    payload: {
      params: {
        lang,
        items
      },
    }
  };
}

export function getMultipleProductStoreAvailabilityActionComplex() {
  return {
    type: ActionTypes.STORES_MAP.GET_MULTIPLE_PRODUCT_STORE_AVAILABILITY_COMPLEX,
  };
}

export function getStoresAvailabilityAndSetActiveIdAction(lang: string) {
  return {
    type: ActionTypes.STORES_MAP.GET_MULTIPLE_PRODUCT_STORE_AVAILABILITY_AND_SET_ACTIVE_ID,
    payload: {
      params: {
        lang
      }
    }
  };
}

